import { getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import addLogDocument from "../addLogDocument.js"; // Assuming a custom log function similar to FlutterFlow
import { useState } from "react";
import { auth, dbCentral } from "../../config/FirebaseConfig.js";

// Example function to create a new client in a React project
const createNewPartner = async (
  phone,
  email,
  ville,
  postal,
  entreprise,
  partner_type,
  payment_allowed,
  adresse,
  oid,
  token,
  prenom,
  prefix
) => {
  // Define the endpoint URL
  const url = prefix + `organisations/${oid}/partner`;

  // Define the request body
  const body = {
    phone,
    email,
    ville,
    postal,

    entreprise,
    partner_type,
    payment_allowed,
    oid,
    adresse,
    prenom,
  };

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    let start = new Date();
    // Make the POST request
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body), // Encode the body as JSON
    });

    const currentUser = auth.currentUser;

    if (!currentUser) {
      return "User not logged in";
    }

    const userRef = doc(dbCentral, "user", currentUser.uid);
    const userSnapshot = await getDoc(userRef);

    if (!userSnapshot.exists()) {
      return "User document not found";
    }

    const orgId = userSnapshot.get("org_id");
    const responseText = await response.text();
    let end = new Date();
    let elapsed = end - start;
    // Add log document
    await addLogDocument(
      url,
      prefix,
      userRef.id,
      orgId,
      response.status.toString(),
      "", // Any other optional fields
      "",
      JSON.stringify(body), // The request body as a string
      responseText,
      "POST",
      elapsed
    );

    // Check if the request was successful
    if (response.ok) {
      const result = JSON.parse(responseText);
      const id = result?.["user_created"]?.id ?? null;
      return id;
    } else {
      // Handle error response
      return `Failed to create user: ${response.status}`;
    }
  } catch (error) {
    // Handle exceptions
    return `Exception occurred: ${error.message}`;
  }
};

export default createNewPartner;
